import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FaArrowCircleLeft } from "react-icons/fa";
import { IconContext } from "react-icons";
import InstagramGallery from "../../components/InstagramGallery";

export const Event = () => {
  useEffect(() => {
    setTimeout(() => {
      const titre = document.getElementById('page-titre');
      if (titre) titre.scrollIntoView({ behavior: 'auto' });
    }, 0);
  }, []);

  return (
    <main className="min-h-screen bg-[#0B0B0F] text-white">
      <div className="p-5">
        <IconContext.Provider value={{size: "2em"}}>
          <NavLink to={"/"} className="text-white hover:text-gray-400 transition-colors">
            <FaArrowCircleLeft />
          </NavLink>
        </IconContext.Provider>
      </div>
      
      {/* Titre de la page en haut */}
      <div className="pt-6 pb-4 text-center">
        <h1 id="page-titre" className="text-4xl md:text-5xl font-bold text-white tracking-tight">VOITURES</h1>
        <div className="w-24 h-1 bg-white mx-auto mt-4 mb-8"></div>
      </div>

      
      {/* Utilisation du composant InstagramGallery pour afficher les photos d'événements */}
      <div className="px-4 pb-12">
        <InstagramGallery category="Voitures" />
      </div>
    </main>
  );
};
